import React from "react";
import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { Button, Grid } from "@mui/material";
import { isMobile } from "react-device-detect";

import useStyle from "./Suppot.style";
import CreatNew from "./CreatNew";
import MyTickets from "./MyTickets";
import QuerySent from "./QuerySent";
import { resetQuerySent } from "../../redux-saga/redux/support/chatsupport";

export default function Modal({ setModalopen, modalopen }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [supportModal, setsupportModal] = useState(false);
  const { subjectCreated } = useSelector((state) => state.supportmodal);

  const classes = useStyle();
  const handleClick = () => {
    setModalopen(false);
  };
  const creatNew1 = () => {
    setsupportModal(false);
    dispatch(resetQuerySent());
  };
  const creatNew2 = () => {
    setsupportModal(true);
    dispatch(resetQuerySent());
  };

  return (
    <>
      <Grid className={classes.ChatModalWrap}>
        <div className={isMobile ? classes.subjectInMobile : classes.head}>
          <Button
            onClick={creatNew1}
            className={`${classes.btnPrimary} ${
              !supportModal ? classes.isactive : " "
            }`}
            variant="contained"
            color="secondary"
          >
            {t("SUPPORT_MODAL.CREATE_NEW")}
          </Button>{" "}
          <Button
            variant="contained"
            color="secondary"
            className={`${classes.btnPrimary} ${
              supportModal ? classes.isactive : " "
            }`}
            onClick={creatNew2}
          >
            {t("SUPPORT_MODAL.MY_TICKETS")}
          </Button>
          {/* <IconButton className={classes.CloseModal}> */}
          <Tooltip
            title="close"
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={handleClick}
          >
            <Button className={classes.btnClose}>
              {" "}
              {/* <img src="/images/close-icon.png" alt="Close" /> */}X{"    "}
              {t("SPORTSEVENTS.CLOSE")}
            </Button>
          </Tooltip>
        </div>
        <Grid className={classes.chatModalContent}>
          {!supportModal && !subjectCreated && <CreatNew />}
          {supportModal && !subjectCreated && (
            <MyTickets setsupportModal={setsupportModal} />
          )}
          {subjectCreated && <QuerySent setsupportModal={setsupportModal} />}
        </Grid>
      </Grid>
    </>
  );
}
